"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.colorHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _styles = require("./styles");
var _HeaderActions = _interopRequireDefault(require("./HeaderActions"));
var _MobileHeader = _interopRequireDefault(require("./MobileHeader"));
var _Logo = _interopRequireDefault(require("./Logo"));
var _Navbar = _interopRequireDefault(require("./Navbar"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const colorHeader = exports.colorHeader = {
  PURPLE: "purple",
  WHITE: "white"
};
const SNETHeader = _ref => {
  let {
    isLoggedIn,
    color,
    isMobileHeaderVisible,
    navbarItems,
    dropdownNavbarItems,
    LoggedInActions,
    LoggedOutActions,
    portalName,
    onLogoClick
  } = _ref;
  const classes = (0, _styles.useStyles)();
  return /*#__PURE__*/_react.default.createElement("header", {
    className: "".concat(classes.snetHeader, " ").concat(color === colorHeader.PURPLE ? classes.purpleHeader : classes.whiteHeader)
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: classes.appBar
  }, isMobileHeaderVisible && /*#__PURE__*/_react.default.createElement(_MobileHeader.default, {
    mobileNavLinks: navbarItems,
    mobileDropDown: dropdownNavbarItems,
    isLoggedIn: isLoggedIn,
    LoggedInActions: LoggedInActions,
    LoggedOutActions: LoggedOutActions,
    color: color
  }), /*#__PURE__*/_react.default.createElement(_Logo.default, {
    className: classes.logoContainer,
    headerColor: color,
    portalName: portalName,
    handleClick: onLogoClick
  }), navbarItems && /*#__PURE__*/_react.default.createElement(_Navbar.default, {
    className: classes.navContainer,
    navbarItems: navbarItems,
    dropdownNavbarItems: dropdownNavbarItems
  }), /*#__PURE__*/_react.default.createElement(_HeaderActions.default, {
    className: classes.headerActionsContainer,
    isLoggedIn: isLoggedIn,
    LoggedInActions: LoggedInActions,
    LoggedOutActions: LoggedOutActions,
    headerType: "desktop"
  })));
};
SNETHeader.propTypes = {
  isLoggedIn: _propTypes.default.bool,
  isMobileHeaderVisible: _propTypes.default.bool,
  portalName: _propTypes.default.string,
  color: _propTypes.default.oneOf([colorHeader.PURPLE, colorHeader.WHITE]),
  LoggedInActions: _propTypes.default.oneOfType([_propTypes.default.func.isRequired, _propTypes.default.object.isRequired]),
  LoggedOutActions: _propTypes.default.oneOfType([_propTypes.default.func.isRequired, _propTypes.default.object.isRequired]),
  onLogoClick: _propTypes.default.func,
  navbarItems: _propTypes.default.arrayOf(_propTypes.default.object),
  dropdownNavbarItems: _propTypes.default.arrayOf(_propTypes.default.object)
};
SNETHeader.defaultProps = {
  isLoggedIn: false,
  navbarItems: [],
  dropdownNavbarItems: [],
  portalName: "",
  color: "white",
  isMobileHeaderVisible: true
};
var _default = exports.default = SNETHeader;